// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GmpC","colBig":"styles_colBig__TFsLK","colSmall":"styles_colSmall__3Le5x"};